import React, { useState } from 'react'
import MEModal from '../../components/MEModal'
import { Form } from 'react-bootstrap'
import { Button } from '@CommonComponents/buttons'
import { useStateValue } from '@State'
import { forceReadingAnalytics } from '../actions'
import { toast } from '@CommonComponents/toast'

export const forceReadingItem = {
  id: 'force-reading',
  label: 'Force Reading',
  icon: 'fa-light fa-book-open',
}

export const ForceReadingModal = ({ user_id, user_full_name, show, close }) => {
  const [currentState] = useStateValue()
  const [markedChapterList, setMarkedChapterList] = useState([])

  const handleChapterCheck = (e) => {
    if (markedChapterList.includes(e.target.value)) {
      setMarkedChapterList(markedChapterList.filter(ch => ch !== e.target.value))
    } else {
      setMarkedChapterList([...markedChapterList, e.target.value])
    }
  }

  const submitAnalytics = async () => {
    let data = {
      user_id: user_id,
      chapter_list: markedChapterList,
    }
    close()
    let resp = await forceReadingAnalytics(data)

    if (resp.status === 204) {
      toast.success(`Analytics Updated - Successfully forced analytics for ${user_full_name}.`)
    } else {
      toast.error(resp.message)
    }
  }

  return (
    <MEModal show={show} close={close} title="Record Reading Completion">
      <form onSubmit={e => e.preventDefault()}>
        <p className="mb-5">
          Select any chapters that you wish the reading to be marked as
          completed. Any selected chapter will be set to 100% completion
          regardless of their previous status.
        </p>
        {currentState.chapterData.map(i => (
          <div key={i.id} className="mb-1">
            <input
              value={i.id}
              type="checkbox"
              className="mr-3"
              onChange={handleChapterCheck}
            />
            <Form.Label>{i.title}</Form.Label>
          </div>
        ))}
        <Button
          className="mt-5 me-btn me-btn-primary"
          type="button"
          onClick={submitAnalytics}
        >
          Record reading completion
        </Button>
      </form>
    </MEModal>
  )
}
